export default "__VITE_ASSET__ChDJQCt5__"